<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="邮箱：" prop="mail">
                <el-input v-model="model.mail" :disabled="true" style="width: 192px"></el-input>
            </el-form-item>
            <el-form-item label="动态类型：" prop="moment_type">
                <el-select clearable v-model="model.moment_type" placeholder="请选择" @change="momentTypeChange">
                    <el-option v-for="item in enuObj('moment_type')" :key="'moment_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所在分类：" prop="cate_id">
                <el-select clearable v-model="model.cate_id" placeholder="请选择">
                    <el-option v-for="item in cateList" :key="'cl'+item.id" :label="item.cate_name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所在话题：" prop="topic_id">
                <el-select clearable v-model="model.topic_id" placeholder="请选择">
                    <el-option v-for="item in topicList" :key="'tp'+item.id" :label="item.topic_name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标签：" prop="tags">
                <el-input v-model="model.tags" style="width: 192px"></el-input>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="动态内容：" prop="content" v-if="model.moment_type==1 || model.moment_type=='1' || model.moment_type==3 || model.moment_type=='3'">
                <el-input v-model="model.content" type="textarea" rows="6"></el-input>
            </el-form-item>
            <el-form-item label="分享图：" prop="imgpath" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess2"
                    :before-upload="beforeUpload">
                    <img v-if="model.share_img" :src="model.share_img" class="upImg" style="width: 160px;height: 128px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 160px;height: 128px;line-height: 128px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 400px</span>
            </el-form-item>
            <el-form-item label="图片集：" prop="imgs" v-if="model.moment_type==1 || model.moment_type=='1'">
                <div class="imgsBox" v-for="(img, idx) in img_list" :key="img">
                    <el-image style="width: 160px; height: 160px" :src="img" :preview-src-list="img_list"></el-image>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="removePic(idx)" circle style="position: absolute;right: 4px;bottom: 4px"></el-button>
                </div>
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <i class="el-icon-plus img-uploader-icon" style="width: 160px;height: 160px;line-height: 160px"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="文章内容：" prop="content_txt" v-if="model.moment_type==2 || model.moment_type=='2'">
                <vue-ueditor-wrap v-model="content1" :config="myConfig" editor-id="container" @ready="UEditorReady"></vue-ueditor-wrap>
            </el-form-item>
            <el-form-item label="封面图：" prop="imgs" v-if="model.moment_type==2 || model.moment_type=='2'">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess1"
                    :before-upload="beforeUpload1">
                    <img v-if="img_list && img_list.length>0" :src="img_list[0]" class="upImg" style="width: 343px;height: 140px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 343px;height: 140px;line-height: 140px"></i>
                    <div slot="tip" class="el-upload__tip">建议尺寸：686px * 280px</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="视频地址：" prop="video_url" v-if="model.moment_type==3 || model.moment_type=='3'">
                <el-input v-model="model.video_url" style="width: 400px"></el-input>
                <el-button type="primary" @click="showVideo" style="margin-left: 20px">预 览</el-button>
            </el-form-item>
            <!-- <el-form-item label="浏览量：" prop="view_count">
                <el-input v-model.number="model.view_count" style="width: 192px"></el-input>
            </el-form-item>
            <el-form-item label="点赞量：" prop="like_count">
                <el-input v-model.number="model.like_count" style="width: 192px"></el-input>
            </el-form-item> -->
            <el-form-item label="审核状态：" prop="sh_state">
                <el-select clearable v-model="model.sh_state" placeholder="请选择">
                    <el-option v-for="item in enuObj('shstate')" :key="'shstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否置顶：" prop="is_top">
                <el-select clearable v-model="model.is_top" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'is_top'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="置顶排序：" prop="top_index">
                <el-input v-model.number="model.top_index" style="width: 192px"></el-input>
            </el-form-item>
            <el-form-item label="话题置顶：" prop="topic_top">
                <el-select clearable v-model="model.topic_top" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'topic_top'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import config from '@/config'
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    name: 'momentEdit',
    mixins: [editutil],
    components: {VueUeditorWrap},
    props: {
        cateList: {
            type: Array,
            default() {
                return [];
            }
        },
        topicList: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            model: {
                member_id: '',
                mail: '5948710@qq.com',
                is_auth: '',
                car_type: '',
                face: '',
                ip_add: '',
                province: '',
                add_time: '',
                moment_type: '1',
                tags: '',
                content: '',
                content_txt: '',
                share_img: '',
                imgs: '',
                view_count: '0',
                like_count: '0',
                comment_count: '0',
                is_top: '0',
                top_index: '1',
                sh_state: '1',
                is_del: '0',
                cate_id: '',
                topic_id: '',
                topic_top: '0',
                video_url: '',
            },
            getObj:{
                url:'/api/admin/moment/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['shstate', 'moment_type', 'yesNo'],
            rules: {
                moment_type: [
                    {required: true, message: '动态类型不能为空', trigger: 'blur'}
                ],
                sh_state: [
                    {required: true, message: '审核状态不能为空', trigger: 'blur'}
                ],
                is_top: [
                    {required: true, message: '是否置顶不能为空', trigger: 'blur'}
                ],
                topic_top: [
                    {required: true, message: '话题置顶不能为空', trigger: 'blur'}
                ],
            },
            myConfig: {
                //你的UEditor资源存放的路径,相对于打包后的index.html
                UEDITOR_HOME_URL: '/ueditor/',
                //编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled: false,
                //初始容器宽度
                initialFrameWidth: '100%',
                //初始容器高度
                initialFrameHeight: 340,
            },
            content1: '',
            editor: null,
            img_list: [],
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "moment",
            },
            mail_dis: false,
        };
    },
    methods: {
        loadOtherData(){
            if(this.id <= 0){
                this.content1 = ''
                this.img_list = []
            }
            //this.editor = VueUeditorWrap.getEditor('container');
            
        },
        UEditorReady() {
            //编辑器实例
            this.editor = UE.getEditor('container');
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    this.model.imgs = JSON.stringify(this.img_list)
                    this.model.content_txt = this.content1
                    if(this.model.moment_type ==2 || this.model.moment_type == '2'){
                        let txt = this.editor.getContentTxt();
                        if(txt.length < 50){
                            this.model.content = txt
                        }else {
                            this.model.content = txt.substring(0, 50)
                        }
                    }
                    let config = {
                        url:'/api/admin/moment/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.content1 = this.model.content_txt+""
            this.model.moment_type = this.model.moment_type+""
            this.model.sh_state = this.model.sh_state+""
            this.model.is_top = this.model.is_top+""
            this.model.topic_top = this.model.topic_top+""
            this.img_list = JSON.parse(this.model.imgs)
        },
        momentTypeChange(e){
            this.img_list = []
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.img_list.push(res.data[0])
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess1(res, file){
            this.img_list = []
            if(res.code ==1){
                this.img_list.push(res.data[0])
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess2(res, file){
            if(res.code ==1){
                this.model.share_img = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        beforeUpload1(file){
            if(this.img_list.length>=9){
                this.$message.error('最多上传9张图片');
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        removePic(idx){
            this.img_list.splice(idx,1)
        },
        showVideo(){
            window.open(this.model.video_url)
        }
    }
};
</script>